import React, { Component } from "react";
import { connect } from "react-redux";
import RequestList from "../components/RequestList";
import RequestCreate from "../components/RequestCreate";

import order from "../order.pdf";
import { history } from "../router";
import { MENTORS_URL } from "../router/urls";
import { getFlows, getForms } from "../actions";

class MainPage extends Component {
	componentDidMount() {
		this.props.getForms();
		this.props.getFlows();
	}

	render() {
		return (
			<div className="content">
				<div className="d-sm-block d-lg-flex justify-content-between align-items-start">
					<h2 className="content__title">Заявка на FastTrack</h2>
					{(this.props.user.is_mentor || this.props.user.is_master_mentor) && (
						<button className="btn btn-sm btn-default" onClick={() => history.push(MENTORS_URL)}>
							Перейти в кабинет ментора
						</button>
					)}
				</div>
				{this.props.mode === "working" && !(this.props.user.is_mentor || this.props.user.is_master_mentor) && (
					<>
						<div className="line" />
						<div className="container-fluid nopad">
							<h4>Оформление заявки на FastTrack</h4>
							<RequestCreate />
						</div>
					</>
				)}
				{this.props.mode === "suspended" && (
					<div className="container-fluid nopad">
						<p style={{ color: "red" }}>Приём заявок временно приостановлен</p>
						<a className="btn-link" target="_blank" href={order} rel="noreferrer">
							Приказ от 19.01.2021 № 3-Пр "О приостановлении приема заявок на получение минигрантов"
						</a>
					</div>
				)}
				<div className="line" />
				<div className="container-fluid nopad">
					<h4>Все заявки</h4>
					<RequestList />
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		mode: state.forms.mode,
		user: state.forms.user || {},
	};
}

const mapDispatchToProps = {
	getForms,
	getFlows,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
